module.exports = __webpack_public_path__ + "static/media/sitelock.f3df484b.svg";